import { render, staticRenderFns } from "./moneyConfig.vue?vue&type=template&id=582a460c"
import script from "./moneyConfig.vue?vue&type=script&lang=js"
export * from "./moneyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports